<template>
  <div>
    <el-dialog title="赠送码使用情况"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               width="1200px"
               @close="emitClose"
               @open="open()">

      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="赠送码"
                      prop="start_product_code_keyword">
          <el-input v-model="query.start_product_code_keyword"
                    placeholder="请输入赠送码"
                    clearable
                    @input="getList()"></el-input>
        </el-form-item>
        <el-form-item label="全部状态"
                      prop="exchange_statuses">
          <el-select v-model="query.exchange_statuses"
                     placeholder="请选择"
                     clearable
                     @change="getList(true)">
            <el-option label="未兑换"
                       value="0"> </el-option>
            <el-option label="兑换中"
                       value="1"> </el-option>
            <el-option label="已兑换"
                       value="2"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商品关键字"
                      prop="product_keyword">
          <el-input v-model="query.product_keyword"
                    placeholder="输入商品关键字"
                    clearable
                    @input="getList()"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="用户"
                      prop="user_keyword">
          <el-input v-model="query.user_keyword"
                    placeholder="输入用户名/手机号"
                    clearable
                    @input="getList()"></el-input>
        </el-form-item> -->

      </el-form>
      <el-table class="table"
                :data="results"
                @selection-change="handleSelectionChange"
                border
                style="width: 100%">
        <el-table-column type="selection"
                         width="50"
                         align="center"
                         fixed="left">
        </el-table-column>
        <el-table-column prop="start_product_code"
                         label="开课码"
                         min-width="150"
                         align="center">
        </el-table-column>
        <el-table-column prop="ref_product_name"
                         label="关联内容"
                         min-width="200"
                         align="center">
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==1"
                    type="success">正常</el-tag>
            <el-tag v-if="scope.row.status==2"
                    type="warning">已经过期</el-tag>
            <el-tag v-if="scope.row.status==3"
                    type="info">已作废</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ref_exchange_status"
                         label="关联兑换状态"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.ref_exchange_status==0"
                    type="info">未兑换</el-tag>
            <el-tag v-if="scope.row.ref_exchange_status==1"
                    type="warning">兑换中</el-tag>
            <el-tag v-if="scope.row.ref_exchange_status==2"
                    type="success">已兑换</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ref_exchange_user_id"
                         label="兑换用户ID"
                         width="60"
                         align="center">
        </el-table-column>
        <el-table-column prop="ref_exchange_user_id"
                         label="兑换用户姓名/手机号"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.ref_exchange_status==2">{{scope.row.ref_exchange_user_realname}}/{{scope.row.ref_exchange_user_mobile}}</span>
            <span>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="ref_exchange_finish_time"
                         label="兑换时间"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.ref_exchange_finish_time">{{$moment(scope.row.ref_exchange_finish_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>

        <el-table-column label="创建时间"
                         min-width="90"
                         align="center">
          <template slot-scope="scope">
            <span>{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效时间"
                         min-width="130"
                         align="center">
          <template slot-scope="scope">
            <span>{{$moment(scope.row.start_time).format('YYYY-MM-DD HH:mm')}}至{{$moment(scope.row.end_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="100"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="info"
                     :underline="false">复制链接</el-link>
          </template>
        </el-table-column>

      </el-table>
      <div class="footer">
        <el-button @click="handleCancle()">批量作废</el-button>

        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  startProductCodelist,
  startProductCodePut,
} from '@/api/productExchange'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      dialogFormVisible: this.visible,
      chooseList: [],
      results: [],
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      start_code_task_id: null,
    }
  },
  mounted() {},
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
    editRow(val) {
      this.query.start_code_task_id = val.id
    },
  },
  methods: {
    handleCancle() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要作废的数据')
        return
      }
      this.$confirm('确定要作废这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })
        let row = []
        ids.map((item) => {
          row.push({
            id: item,
            status: 3,
          })
        })

        startProductCodePut({ rows: row }).then((res) => {
          this.$message.success('操作成功')
          this.getList()
        })
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    emitClose() {
      this.query.pageIndex = 1
      this.start_code_task_id = null
      this.results = []
      this.$emit('close')
    },
    getList() {
      let data = this.query
      startProductCodelist(data).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    open() {
      this.getList()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.getList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
  },
}
</script>

<style lang="less" scoped>
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;

  height: 32px;
  margin: 0px 5px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>